<template>
  <div>请稍后</div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui';
import QRCode from 'qrcodejs2';
import BarCode from 'jsbarcode';
import api from '../api';
import utils from '../common/utils';

export default {
  data() {
    return {
      test: 'aa',
      YY_USER_ID: '',
      YY_len: '',
      YY_slen: '',
      YY_td: '',
      YY_type: '',
      form: {
        blh: 'xxxxxxxx',
        cardfee: '0.00',
        name: 'XXX',
        score: '0',
        sex: '男',
        vip: '普通',
      },
      popupVisible: false,
      menuShow: ['0', '0', '0', '0', '0', '0', '0'],
    };
  },
  methods: {
    toPage(path) {
      this.$router.push({
        path,
        query: {
          YY_USER_ID: this.$route.query.YY_USER_ID,
          openId: this.$route.query.openId || this.openId,
        },
      });
    },

    loadPartnerInfo(clientId, openId) {
      const _this = this;
      const url = `http://app.kq123.com/QSYYAPI/api/wx/vip?mzid=${clientId}&openid=${openId}`;
      Indicator.open('加载中...');

      api.get(_this, url, {
        mzid: clientId,
        openid: openId,
      }, (res) => {
        Indicator.close();
        let paramStr = '';
        const query = _this.$route.query
        Object.keys(query).forEach((key) => {
          paramStr += "&" + key + '=' + query[key]
        })
        // if (_this.$route.query.YY_len) {
        //   paramStr = `&len=${_this.$route.query.YY_len}&slen=${_this.$route.query.YY_slen}&td=${_this.$route.query.YY_td}`;
        // }

        if (query.useblh == 1) {
          // 有号预约
          window.location.href = `http://wx.kq120.com/yyhis/?zsbm=${this.$store.state.baseInfo.clientID
            }&blh=${res.data.Data.blh}${paramStr}`;
        } else {
          // 无号预约
          window.location.href = `http://wx.kq120.com/yyhis/?zsbm=${this.$store.state.baseInfo.clientID}${paramStr}`;
        }
      }, (err) => {
        //                    Toast("网络出错，请稍后再试");
        Indicator.close();
      });
    },
    loadUserCenterMenu() {
      Indicator.open('加载中...');
      api.getFormUrl(this, this.$api.getUserCenterMenu, null, (res) => {
        console.log(res);
        this.menuShow = res.split('');
      }, () => {
        Indicator.close();
      });
    },


  },
  mounted() {
    const _this = this;
    const YY_USER_ID = this.$route.query.YY_USER_ID || '';
    if (YY_USER_ID) {
      this.YY_USER_ID = YY_USER_ID;
      this.$store.commit('set', {
        YY_USER_ID,
      });
    }
    utils.doIF(() => {
      //                if(_this.hasBind)
      _this.loadPartnerInfo(this.$store.state.baseInfo.clientID, this.$route.query.openId);
      _this.loadUserCenterMenu();
    }, () => this.$store.state.baseInfo && this.$route.query.openId);
  },
};

</script>

<style lang="scss">
@import "../assets/styles/common.css";

.page {
  height: 100%;
  overflow: hidden;
  position: relative;
  background: #eaeaea
}

.head-view {
  width: 100%;
  position: relative;
}

.card-view {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 20px;
}

.person-info {
  flex: 1;
}

.patient-info {
  padding: 10px 0 4px 0;
}

.qrcode {
  width: 106px;
  height: 106px;
  margin: 0 15px;
  padding: 7px 10px 2px 10px;
  box-sizing: border-box;
}

.font-color-1 {
  color: #ffe0b0;
}

.button-1 {
  color: #5a4a31;
  margin-left: 7px;
  padding: 3px 11px;
  background-size: cover;
  text-align: center;
  border-radius: 100px;
  background: linear-gradient(45deg, #a1a1a1, #ebebeb);
}

.click-item {
  background: white;
  height: 50px;
  font-size: 14px;

  img {
    width: 16px;
    height: 14px;
    margin-right: 12px;
    margin-left: 16px;
  }
}

.click-item:not(:last-child) {
  border-bottom: 1px solid #efefef;
}

.arrow_right {
  width: 12px;
  height: 18px;
}

.discount-code {
  left: 5rem;
  right: 5rem;
  padding: 8px 15px;
  min-width: 20rem;
}

.canvas>* {
  margin: auto;
  display: block;
}
</style>
